export const MANAGE_SALES_RETURNS_PERMISSION_ID = 1004;

export const canManageSalesReturns = (permissions = []) =>
  Array.isArray(permissions) && permissions.map(Number).includes(MANAGE_SALES_RETURNS_PERMISSION_ID);
